import { css } from 'aphrodite';
import { Controller } from 'react-hook-form';
import { Input } from '../../../../../../web/components-v2/Input';
import { IFormField } from '../../../../../models/Api';
import { styleSheet } from '../styles';

interface IProps {
	field: IFormField<string>;
	control: any;
	formState: any;
}

export const StringInput = ({ field, control, formState }: IProps) => {
	return (
		<Controller
			name={`customProperties.${field.id}`}
			control={control}
			render={({ field: { ref, ...fieldProps } }) => (
				<>
					<Input type='text' value={fieldProps.value || ''} {...fieldProps} />
					{formState?.errors.customProperties?.[field.id] && (
						<p className={css(styleSheet.errorMessage)}>{formState?.errors.customProperties[field.id]?.message}</p>
					)}
				</>
			)}
		/>
	);
};
